import React, { ReactNode } from 'react'

type Props = {
  children: ReactNode
  onClick?: (e: React.MouseEvent) => void
  className?: string
}

const BaseCard: React.FC<Props> = (props) => {
  let baseClasses = 'bg-white rounded-lg shadow-lg p-4'
  if (props.onClick) {
    baseClasses += ' cursor-pointer'
  }

  return (
    <div
      className={`${baseClasses} ${props.className}`}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  )
}

export default BaseCard
